import React from 'react';
import hoc from './FieldHOC';

class UploadField extends React.Component {
  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    let field = this.props.field;
    return (
      <div>
        <label htmlFor={field.get('name')}>{this.props.title || field.get('title')}</label>
        {this.props.errorComponent}
        <input
          className="form-control"
          type="file"
          name={this.props.name}
          placeholder={field.prop('hintText')}
          tabIndex={this.props.tabIndex}
          onChange={this.onChange.bind(this)}
        />
      </div>
    );
  }
}

export default hoc(UploadField);
